// extracted by css-extract-rspack-plugin
export default {"buttonContainer":"DashboardAlertsButton_buttonContainer__xbTv5","badge":"DashboardAlertsButton_badge__Z5_1O"};